import { apiFetch } from './httpClient';

async function http(path, options = {}) {
  const resp = await apiFetch(path, options);
  if (!resp.ok) {
    const error = new Error(`${resp.status} ${resp.statusText}`);
    error.status = resp.status;
    try {
      const data = await resp.json();
      error.message = data.detail || error.message;
    } catch {
      // If response is not JSON, use default message
    }
    throw error;
  }
  if (resp.status === 204) return null;
  return resp.json();
}

export const authService = {
  forgotPassword: (email) =>
    http('/auth/forgot-password', {
      method: 'POST',
      body: JSON.stringify({ email }),
    }),

  verifyResetCode: (email, code) =>
    http('/auth/verify-reset-code', {
      method: 'POST',
      body: JSON.stringify({ email, code }),
    }),

  resetPassword: (email, newPassword, resetToken) =>
    http('/auth/reset-password', {
      method: 'POST',
      body: JSON.stringify({ email, new_password: newPassword, reset_token: resetToken }),
    }),
};
